module.exports = __webpack_public_path__ + "static/media/tecmilenio-1@2x.9f95a0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/tecmilenio-1@2x.png
// module id = 78
// module chunks = 0